export default "__VITE_ASSET__D43Y6bLm__"